export default __webpack_public_path__ + "static/media/green-bin-icon.7ccf6dc8.svg";